import { getTimeFromDate } from './getTimeFromDate';
export var getNextHour = function getNextHour() {
  var date = new Date();
  date.setHours(date.getHours() + 1);
  date.setMinutes(0);
  return getTimeFromDate(date);
};